import { Spacing, withTheming, Shape, getFocusStyles } from '@doordash/design-language';
import styled, { css } from 'styled-components';

var WRAPPER_WIDTH = Spacing.XLarge;
var CONTENT_PADDING = "0 ".concat(Spacing.XxSmall, "px");
var PageNav = withTheming(styled.button.withConfig({
  displayName: "styles__PageNav",
  componentId: "sc-izrruq-0"
})(["display:flex;align-items:center;justify-content:center;height:", "px;width:", "px;padding:", ";cursor:pointer;background-color:", ";border:0;box-shadow:inset 0 0 0 ", "px ", ";border-radius:", "px;&:focus{", ";", ";}&:active{", "}&:hover{", "}"], WRAPPER_WIDTH, WRAPPER_WIDTH, CONTENT_PADDING, function (props) {
  return function (_ref) {
    var theme = _ref.theme;
    return props.isDisabled ? theme.Colors.PaginationNumberedNavigationBackgroundDisabled : theme.Colors.PaginationNumberedNavigationBackground;
  };
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.BorderWidth.PaginationNumberedUnselected;
}, function (props) {
  return function (_ref3) {
    var theme = _ref3.theme;
    return props.isDisabled ? theme.Colors.PaginationNumberedNavigationBorderDisabled : theme.Colors.PaginationNumberedNavigationBorder;
  };
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.Shape.PaginationNumbered === Shape.Circle ? WRAPPER_WIDTH : theme.BorderRadius.ButtonDefault;
}, getFocusStyles(), function (props) {
  return props.isDisabled && 'cursor: not-allowed;';
}, function (props) {
  return function (_ref5) {
    var theme = _ref5.theme;
    return props.isDisabled ? 'cursor: not-allowed;' : css(["background-color:", ";box-shadow:inset 0 0 0 ", "px ", ";"], theme.Colors.PaginationNumberedNavigationBackgroundPressed, theme.BorderWidth.PaginationNumbered, theme.Colors.PaginationNumberedNavigationBorderPressed);
  };
}, function (props) {
  return function (_ref6) {
    var theme = _ref6.theme;
    return props.isDisabled ? 'cursor: not-allowed;' : css(["background-color:", ";box-shadow:inset 0 0 0 ", "px ", ";"], theme.Colors.PaginationNumberedNavigationBackgroundHovered, function (_ref7) {
      var theme = _ref7.theme;
      return theme.BorderWidth.PaginationNumbered;
    }, theme.Colors.PaginationNumberedNavigationBorderHovered);
  };
}));
PageNav.displayName = 'PageNav';
var PageNumber = withTheming(styled.button.withConfig({
  displayName: "styles__PageNumber",
  componentId: "sc-izrruq-1"
})(["display:flex;justify-content:center;align-items:center;height:", "px;min-width:", "px;padding:", ";cursor:pointer;border:0;background-color:", ";box-shadow:inset 0 0 0 ", "px ", ";border-radius:", "px;&:focus{", ";}&:hover{", "}&:active{", "}"], WRAPPER_WIDTH, WRAPPER_WIDTH, CONTENT_PADDING, function (props) {
  return function (_ref8) {
    var theme = _ref8.theme;
    return props.isCurrent ? theme.Colors.PaginationNumberedSelectedBackground : theme.Colors.PaginationNumberedUnselectedBackground;
  };
}, function (props) {
  return function (_ref9) {
    var theme = _ref9.theme;
    return props.isCurrent ? theme.BorderWidth.PaginationNumbered : theme.BorderWidth.PaginationNumberedUnselected;
  };
}, function (props) {
  return function (_ref10) {
    var theme = _ref10.theme;
    return props.isCurrent ? theme.Colors.PaginationNumberedSelectedBorder : theme.Colors.PaginationNumberedUnselectedBorder;
  };
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.Shape.PaginationNumbered === Shape.Circle ? WRAPPER_WIDTH : theme.BorderRadius.ButtonDefault;
}, getFocusStyles(), function (props) {
  return function (_ref12) {
    var theme = _ref12.theme;
    return "\n      background-color: ".concat(props.isCurrent ? theme.Colors.PaginationNumberedSelectedBackgroundHovered : theme.Colors.PaginationNumberedUnselectedBackgroundHovered, ";\n      box-shadow: inset 0 0 0 ").concat(theme.BorderWidth.PaginationNumbered, "px\n        ").concat(props.isCurrent ? theme.Colors.PaginationNumberedSelectedBorderHovered : theme.Colors.PaginationNumberedUnselectedBorderHovered, ";\n    ");
  };
}, function (props) {
  return function (_ref13) {
    var theme = _ref13.theme;
    return "\n      background-color: ".concat(props.isCurrent ? theme.Colors.PaginationNumberedSelectedBackgroundPressed : theme.Colors.PaginationNumberedUnselectedBackgroundPressed, ";\n      box-shadow: inset 0 0 0 ").concat(theme.BorderWidth.PaginationNumbered, "px\n        ").concat(props.isCurrent ? theme.Colors.PaginationNumberedSelectedBorderPressed : theme.Colors.PaginationNumberedUnselectedBorderPressed, ";\n    ");
  };
}));
PageNumber.displayName = 'PageNumber';
var PageEllipsisWrapper = styled.div.withConfig({
  displayName: "styles__PageEllipsisWrapper",
  componentId: "sc-izrruq-2"
})(["width:", "px;display:flex;align-items:center;justify-content:center;padding:", ";"], WRAPPER_WIDTH, CONTENT_PADDING);
PageEllipsisWrapper.displayName = 'PageEllipsisWrapper';

export { PageEllipsisWrapper, PageNav, PageNumber };
